/**
 * オブジェクトから対象のキーを非破壊的に除外する
 * @param object 除外対象のオブジェクト
 * @param targetKey 対象のオブジェクトから除外したいキー
 */
export const removeObjectKey = <T>(object: T, targetKey: keyof T): T => {
  // eslint-disable-next-line unused-imports/no-unused-vars
  const { [targetKey]: _, ...rest } = object;
  return rest as T;
};
